import gsap from '@gsap/shockingly'
import { lerp } from '../utils/utils';

export default class Video {
	constructor(element, options)
	{
		// this is an interace for Video Class. It lets us know which methods to expect, but we won't actually use it ...

		/**
		 * 
		 * We can pass options as on object
		 * 
		 * let options = 
		 * {
		 * autoplay : true,
		 * loop: true,
		 * muted: true,
		 * playsinline: true,
		 * controls: true,
		 * }
		 * 
		 */

		this.options = options;

		this.isPlaying = false;
		this.isMuted = true;
		this.duration = 0;
		this.element = element;
		this.video;
		this.progressBar = element.querySelector('.progress-bar');
		this.progressElement = element.querySelector('.progress-bar span');
		this.setProgress = gsap.quickSetter(this.progressElement, 'left', '%');

		this.buttons = 
		{
			play : this.element.querySelector('.play-button'),
			replay : this.element.querySelector('.replay-button'),
			mute: this.element.querySelector('.mute-button')
		}

		this.buttons.play && this.buttons.play.addEventListener('click', () =>
		{
			if (this.isPlaying)
			{
				this.pause();
			} else
			{
				this.play();
			}
		})

		this.buttons.replay && this.buttons.replay.addEventListener('click', () =>
		{
			this.restart();
		})

		this.buttons.mute && this.buttons.mute.addEventListener('click', () =>
		{
			if (this.isMuted)
			{
				this.setVolume(1);
			} else
			{
				this.mute();
			}
		})

	}
	play(){
		this.isPlaying = true;
		this.buttons.play.classList.add('playing');
	}
	pause(){
		this.isPlaying = false;
		this.buttons.play.classList.remove('playing');
	}
	restart(){

	}
	mute(){
		this.isMuted = true;
		this.buttons.mute.classList.add('muted');
	}
	setTime(percentage)
	{
		this.setProgress(percentage)
	}
	setVolume(amount){
		this.isMuted = false;
		this.buttons.mute.classList.remove('muted');
	}
	updateTimeElapsed(duration, timeElapsed){

		this.totalDuration = duration;
		
		this.percentageProgress = parseFloat((timeElapsed / duration)) * 100;

		if (this.percentageProgress <= 100 && this.percentageProgress >= 0)
		{
			this.progressElement.classList.add('tracking');
		}
		else
		{
			this.progressElement.classList.remove('tracking');
		}

		if (this.percentageProgress <= 100 && this.percentageProgress >= 0)
		{
			this.progressElement.classList.add('active');
			this.setProgress(this.percentageProgress)
		} 
	}
	getSeek(duration, currentTime)
	{
		this.progressBar.addEventListener('click', (e)=> 
		{
			e.preventDefault();
			e.stopPropagation();
			let width = this.progressBar.offsetWidth;
			let rect = e.target.getBoundingClientRect();
			let x = e.clientX - rect.left;
			let percentOnClick = (x / width) * 100;
	
			this.setTime(percentOnClick);
		})
	}
	hideControls()
	{
		for (let button in this.buttons)
		{
			this.buttons[button].style.display = 'none'
		}

	}
	hideProgress()
	{
		this.progressBar.style.display = 'none';
	}
}